import { MB_CONFIG } from '../config'

var API_URL = MB_CONFIG.API_URL + '/auth'

export const authAPI = {
    LOGIN: login => window.axios.post(API_URL, login),
    LOGOUT: () => window.axios.get(API_URL + '/logout'),
    REFRESH: () => window.axios.get(API_URL + '/refresh'),
}
